export default __webpack_public_path__ + "static/media/empty_note.6efa22d7.png";